import React from 'react';
import { Helmet } from 'react-helmet';
import LoginForm from './components/LoginForm';
import SecurityBadges from './components/SecurityBadges';
import MarketPreview from './components/MarketPreview';

const LoginPage = () => {
  return (
    <>
      <Helmet>
        <title>Sign In - CryptoInvestor Pro | Advanced Cryptocurrency Trading Platform</title>
        <meta name="description" content="Sign in to CryptoInvestor Pro for advanced cryptocurrency trading, portfolio management, and technical analysis with PTS-WIZARD-V3 algorithm." />
        <meta name="keywords" content="cryptocurrency trading, login, crypto portfolio, technical analysis, PTS-WIZARD-V3" />
      </Helmet>
      <div className="min-h-screen bg-background">
        {/* Main Content */}
        <div className="flex min-h-screen">
          {/* Left Panel - Login Form */}
          <div className="flex-1 flex items-center justify-center px-6 py-12 lg:px-8">
            <div className="w-full max-w-md">
              <LoginForm />
            </div>
          </div>

          {/* Right Panel - Security & Market Info */}
          <div className="hidden lg:flex lg:flex-1 lg:flex-col bg-muted/30 border-l border-border">
            <div className="flex-1 flex items-center justify-center px-8 py-12">
              <div className="w-full max-w-md space-y-8">
                {/* Security Badges */}
                <SecurityBadges />
                
                {/* Market Preview */}
                <MarketPreview />
              </div>
            </div>

            {/* Footer */}
            <div className="px-8 py-6 border-t border-border">
              <div className="text-center">
                <p className="text-xs text-muted-foreground">
                  © {new Date()?.getFullYear()} CryptoInvestor Pro. All rights reserved.
                </p>
                <p className="text-xs text-muted-foreground mt-1">
                  Secure trading platform with advanced analytics
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* Mobile Security Info */}
        <div className="lg:hidden px-6 py-8 bg-muted/30 border-t border-border">
          <div className="max-w-md mx-auto">
            <SecurityBadges />
          </div>
        </div>

        {/* Mobile Footer */}
        <div className="lg:hidden px-6 py-4 bg-card border-t border-border">
          <div className="text-center">
            <p className="text-xs text-muted-foreground">
              © {new Date()?.getFullYear()} CryptoInvestor Pro. All rights reserved.
            </p>
          </div>
        </div>
      </div>
    </>
  );
};

export default LoginPage;